// Minimal adapter for useGlobSetting to support AI components
// Pulls values from existing env.js
import { imgDomain, urlDomain } from '@/configs/env';

export const useGlobSetting = () => {
  return {
    title: 'Web Innovation Admin',
    apiUrl: urlDomain,
    h5Url: '',
    ossUrl: imgDomain,
    shortName: 'Web_Innovation_Admin',
    urlPrefix: '',
    uploadUrl: '',
  };
};

export default useGlobSetting;

